import * as yup from "yup";

const schema = yup.object().shape({
  time: yup.string().required(),
  date: yup.string().required(),
  status: yup.string().required(),
  lead: yup.string().required(),
});

export default schema;
